export default "__VITE_ASSET__BpL6axUd__"